import React from 'react';
import { Link } from 'react-router-dom';
import styled, {keyframes} from 'styled-components';
import { FaLinkedin, FaGithub, FaMedium } from 'react-icons/fa';
import { SiSubstack } from 'react-icons/si';
import profPic from '../images/profpic.png';

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-30px);
  }
`;

// Styled Components
const ContactBox = styled.div`
  margin-top: 10px; // Space between icons and contact box
  padding: 15px;
  color: white;
  text-align: center;
`;

const ContactText = styled.p`
  margin: 1px; // Remove default margin
  font-size: 1.4em;
  a {
    color: white;
    margin: 10px;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: gray;
    }
  }
`;

const HomeContainer = styled.div`
  height: 100vh; // Full viewport height
  display: flex;
  flex-direction: column;
  justify-content: center; // Vertically center
  align-items: center; // Horizontally center
  position: relative; // Relative positioning for navigation links
  background-color: black; // Optional: Set a background color
  animation: ${float} 3s ease-in-out infinite;
`;

const ProfileImage = styled.img`
  height: 300px;
  border-radius: 50%;
  opacity: 1;

  @media (max-width: 600px) {
    height: 120px;
  }
`;

const SocialLinks = styled.div`
  margin-top: 20px; // Space between name and icons

  a {
    color: white;
    margin: 10px;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: gray;
    }
  }
`;

const Title = styled.div`
  margin: 0 20px;
  font-size: 35px;
  color: white;
  text-decoration: none;
  transition: transform 0.3s;
`

const ContactLink = styled(Link)`
  font-size: 0.95em;
  color: #aaa;
  text-decoration: none;
  transition: color 0.3s;
  &:hover {
    color: #fff;
  }
`;

const AboutLink = styled(Link)`
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.9em;
  color: #666;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.3s;
  &:hover {
    color: #fff;
  }
`;

const Navigation = styled.div`
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: space-between;
  top:50%;
  left: 0; // Align to the left edge
  right: 0; // Align to the right edge
  transform: translateY(0);

  a {
    margin: 0 20px;
    font-size: 35px;
    color: white;
    text-decoration: none;
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.2);
    }

    @media (max-width: 600px) {
      margin: 0 10px;
      display: flex;
      font-size: 20px;
      align-items: flex-end;
      height: 320px;

      &:hover {
      transform: scale(1);
    }
    }
  }
`;

function Home() {
  return (
    <HomeContainer>
      <ProfileImage src={profPic} alt="Profile Picture"/>
      <Title>Avneet Singh</Title>
      <ContactBox>
        <ContactText>AI/ML Engineer</ContactText>
        <ContactText style={{fontSize: '0.85em', color: '#aaa', margin: '4px 0'}}>Evaluation &amp; Adversarial Robustness &middot; Production ML Systems</ContactText>
        <ContactText style={{fontSize: '0.75em', color: '#666', margin: '2px 0 8px'}}>Tampa, FL</ContactText>
        <ContactText style={{marginTop: '6px'}}><ContactLink to="/contact">Contact</ContactLink></ContactText>
      </ContactBox>
      <SocialLinks>
        <a href="https://www.linkedin.com/in/avneetsinghurl" target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </a>
        <a href="https://github.com/Asingh027" target="_blank" rel="noopener noreferrer">
          <FaGithub />
        </a>
        <a href="https://medium.com/@neetium" target="_blank" rel="noopener noreferrer">
          <FaMedium />
        </a>
        <a href="https://neetium.substack.com" target="_blank" rel="noopener noreferrer">
          <SiSubstack />
        </a>
      </SocialLinks>
      <Navigation>
        <Link to="/career">← Career</Link>
        <Link to="/projects">Projects →</Link>
      </Navigation>
      <AboutLink to="/about">About ↓</AboutLink>
    </HomeContainer>
  );
}

export default Home;
